import { addToast } from '@utils/toast-util.js';

export function copyToClipboard(value: string, label: string) {
    navigator.clipboard.writeText(value);
    addToast(label + ' kopiert');
}
